<a
  class="black-color"
  [queryParams]="notification.sref_params"
  [routerLink]="notification.routerLink | addNextPrefix"
  (click)="onClick()"
>
  <div class="flex-row-all flex-config-align-center">
    <div class="flex-col flex-static notification-image">
      <div class="intrinsic">
        <div class="img" [style.background-image]="notification.image | bg"></div>
        <sb-activity-status-badge class="position-absolute bottom-0 right-0" [size]="'medium'" [status]="'online'" />
      </div>
    </div>
    <div class="flex-col flex-dynamic">
      @if (notification.headline) {
        <h3 class="headline t-8@r charcoal-color">
          @if (headlineIcon) {
            <sb-icon
              class="mr-1@r {{ headlineIcon.colorClass }}"
              [name]="headlineIcon.icon"
              [secondaryColor]="headlineIcon.secondaryColor"
              [size]="'8'"
            />
          }
          {{ notification.headline }}
        </h3>
        @if (notification.text) {
          <div class="t-9@r charcoal-color">{{ notification.text }}</div>
        }
      }
    </div>
    <div class="flex-col center-flex">
      <sb-icon class="cloud-color" [name]="'arrow-right'" [size]="'5'" />
    </div>
  </div>
</a>
